import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getPageArrival, type PageArrival } from "@src/store/slices/navigation";
import { getAtlasSessionId } from "@src/store/slices/opportunityAudit";
import {
  type AuditEntryPoint,
  type AuditState,
  mpAuditOpened,
} from "@src/utils/mixpanel";

/** A link's own entry point wins; otherwise it is read from how the user came. */
export const auditEntryPointOf = (arrival: PageArrival | null): string => {
  if (arrival === null) {
    return "direct_link" satisfies AuditEntryPoint;
  }
  const derived: AuditEntryPoint = arrival.fromSideNav ? "nav" : "in_app";
  return arrival.entryPoint ?? derived;
};

/** The merchant landed on the audit, once the session it shows is known. */
export const trackAuditOpened = createAsyncThunk<void, AuditState>(
  "opportunityAudit/trackAuditOpened",
  (auditState, { getState }) => {
    const auditId = getAtlasSessionId(getState());
    if (auditId === null) {
      return;
    }
    const arrival = getPageArrival(getState());
    mpAuditOpened({
      auditId,
      auditState,
      entryPoint: auditEntryPointOf(arrival),
      previousPage: arrival?.previousPage,
    });
  }
);
